import { apiClient } from './api'

export interface Notification {
  id: string
  notificationType: string
  title: string
  message: string
  metadata: Record<string, unknown>
  readAt: string | null
  createdAt: string
  updatedAt: string
  actorName: string
  actorEmail?: string
  actorFirstName?: string
  actorLastName?: string
  read: boolean
}

export interface NotificationsResponse {
  notifications: Notification[]
}

export interface UnreadCountResponse {
  unreadCount: number
}

export const notificationsService = {
  async getNotifications(): Promise<Notification[]> {
    const response =
      await apiClient.get<NotificationsResponse>('/notifications')
    return response.data.notifications
  },

  async getUnreadCount(): Promise<number> {
    const response = await apiClient.get<UnreadCountResponse>(
      '/notifications/unread_count'
    )
    return response.data.unreadCount
  },

  async markAsRead(notificationId: string): Promise<void> {
    await apiClient.post(`/notifications/${notificationId}/mark_as_read`)
  },

  async markAllAsRead(): Promise<void> {
    await apiClient.post('/notifications/mark_all_as_read')
  },
}
